import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './card-info-page.component.html',
    styleUrls: ['./card-info-page.component.scss']
})
export class CardInfoPageComponent implements OnInit {
    ngOnInit(): void {
        window.scrollTo({ top: 0 });
    }
}
